import { FaqItem } from '../../../../../api/types/faq-content-api';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { useMuiMediaQuery } from '../../../../../utilities/hooks/useMuiMediaQuery';
import { ReactNode } from 'react';
import QuestionLink from '../QuestionLink/QuestionLink';

type RelatedQuestionsProps = {
    relatedQuestions?: FaqItem[];
    title: ReactNode;
    spacing: number;
};

const RelatedQuestions = ({ relatedQuestions, title, spacing }: RelatedQuestionsProps) => {
    const { isMobile } = useMuiMediaQuery();

    if (!relatedQuestions) {
        return <></>;
    }

    return (
        <Stack spacing={isMobile ? spacing - 1 : spacing}>
            {title}
            <Stack divider={<Divider />}>
                {relatedQuestions.map((faq, index) => (
                    <QuestionLink key={`related-question-${index}`} question={faq.question} url={faq.url} />
                ))}
            </Stack>
        </Stack>
    );
};

export default RelatedQuestions;
